"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArmsMountingResetMode = void 0;
var ArmsMountingResetMode;
(function (ArmsMountingResetMode) {
    /**
     * Upper arm going back and forearm going forward
     */
    ArmsMountingResetMode[ArmsMountingResetMode["BACK"] = 0] = "BACK";
    /**
     * Arms going forward
     */
    ArmsMountingResetMode[ArmsMountingResetMode["FORWARD"] = 1] = "FORWARD";
    /**
     * Arms going up to the sides into a tpose
     */
    ArmsMountingResetMode[ArmsMountingResetMode["TPOSE_UP"] = 2] = "TPOSE_UP";
    /**
     * Arms going down to the sides from a tpose
     */
    ArmsMountingResetMode[ArmsMountingResetMode["TPOSE_DOWN"] = 3] = "TPOSE_DOWN";
})(ArmsMountingResetMode = exports.ArmsMountingResetMode || (exports.ArmsMountingResetMode = {}));
